import { isNetworkError } from "common/apiError";

/**
 * Query defaults, shared so tests exercise the real policy rather than a copy
 * of it.
 */
export const queryDefaultOptions = {
  queries: {
    gcTime: Infinity,
    staleTime: 1000 * 30,
    cacheTime: Infinity,
    // A request that never got an answer says nothing about whether it would
    // succeed. Waking a laptop cancels every in-flight call as
    // ERR_NETWORK_CHANGED before the interface is back, and with `retry: false`
    // that first blip was final — the whole app rendered its error states off a
    // connection that came back a second later. Answers from the server,
    // including 4xx and 5xx, are still taken at face value.
    retry: (failureCount, error) => isNetworkError(error) && failureCount < 3,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  },
};
